import { componentsTranslation } from '@/assets/locales/components/components.translation.pl.ts';
import { AppTranslation } from '@/assets/locales/en.ts';
import { generalErrorTranslation } from '@/assets/locales/generalError/generalError.translation.pl.ts';
import { layoutTranslation } from '@/assets/locales/layout/layout.translation.pl.ts';
import { menuTranslation } from '@/assets/locales/menu/menu.translation.pl.ts';
import { validationTranslation } from '@/assets/locales/validation/validation.translation.pl.ts';
import { viewsTranslation } from '@/assets/locales/views/views.translation.pl.ts';

export const pl: AppTranslation = {
  components: componentsTranslation,
  generalError: generalErrorTranslation,
  layout: layoutTranslation,
  menu: menuTranslation,
  validation: validationTranslation,
  views: viewsTranslation,
};
